$(document).ready(function () {
    $('#check-region-applications').click(function () {
        var region_id = { region_id: $('#caregiver-application-region-id :selected').val() };
        $.ajax({
            type: "POST",
            url: "/check_region_applications",
            data: region_id,
            dataType: "json",
            success: function (response) {
                if (response) {
                    window.location.href = response.url;
                }
                else {
                    $("#step4").prop("checked", true);
                }
            }
        });
    });

    $(".application-row").click(function () {
        window.location = $(this).data("href");
    });
});
